import { gql } from "@apollo/client";
import { print } from "@apollo/client/utilities";

export const CREATE_QUERY = print(gql`
  mutation CreatePage($data: CreatePageInput!) {
    createPage(data: $data) {
      id
    }
  }
`);

export interface CreateGql {
  createPage: {
    id: number;
  };
}
